import ItadLogo from './assets/itad_logo.svg';
import HuedMeLogo from './assets/HuedMe_Logo.svg'
import XebiaLogo from './assets/Xebia_Logo.svg'
import TSGLogo from './assets/TSG_Logo.svg'
import SenteLogo from './assets/Sente_Logo.svg'
import VolvoLogo from './assets/Volvo_Logo.svg'
import PPGLogo from './assets/PPG_Logo.svg'

export { ItadLogo, HuedMeLogo, XebiaLogo, TSGLogo, SenteLogo, VolvoLogo, PPGLogo};

export class Constants {
  static readonly SITE_NAME = 'IT Academic Day \'24'
}